import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'ui-toggle',
  standalone: true,
  templateUrl: './ui-toggle.component.html',
  styleUrl: './ui-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiToggleComponent {
  readonly checked = input(false);
  readonly disabled = input(false);
  readonly ariaLabel = input('Toggle');
  readonly toggled = output<boolean>();

  onToggle(nextValue: boolean): void {
    if (this.disabled()) {
      return;
    }

    this.toggled.emit(nextValue);
  }
}
